/* eslint react/prop-types: 0 */
import React, { Fragment } from "react";

import SearchBuildings from "../../../common/SearchBuildings";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme4Styles from "../scss/theme4.module.scss";

class BuildingSearch extends SearchBuildings {
  constructor(props) {
    super(props);
  }

  render() {
    const { propertyTypes, locale, defaultLocale } = this.props;

    return (
      <Fragment>
        <div className={`${theme4Styles.searchColm}`}>
          <div className={`${theme4Styles.filterSearch}`}>
            <input
              type="text"
              className={theme4Styles.field}
              placeholder="City, Address, ZIP Code"
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme4Styles.srch}
              onClick={() => this.searchBuildings()}
            ></button>
          </div>
        </div>
        <div className={`${theme4Styles.filterC}`}>
          <div className={`${theme4Styles.filterRow}`}>
            <div className={theme4Styles.colm}>
              <select
                className={theme4Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
          </div>
          <div className={`${theme4Styles.filterBtns}`}>
            <button
              className={`${theme4Styles.btn} ${theme4Styles.btnSm} ${theme4Styles.btnPrimary}`}
              onClick={() => this.searchBuildings()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme4Styles.btn} ${theme4Styles.btnSm} ${theme4Styles.btnDark}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BuildingSearch;
